import styled, { css } from 'styled-components'

export const CardMessagePreviewWrapper = styled.div`
  flex: 1;
  margin-top: 0;
  margin-bottom: auto;
  display: flex;
  flex-direction: column;
  min-width: 330px;
  height: 510px;
`

export const CardMessagePreviewContent = styled.div<{ isValid?: boolean }>`
  ${({ theme, isValid }) => css`
    margin-top: 8px;
    padding: 24px 32px;
    overflow-y: auto;
    overflow-x: hidden;
    word-break: break-word;
    width: 100%;
    height: 100%;
    border: 2px solid
      ${isValid ? theme.ds.colors.primary300 : theme.ds.colors.neutral200};
    border-radius: 8px;
  `}
`
